import {
  OAUTH2_REFRESH_TOKEN,
  OAUTH2_SESSION_TOKEN,
} from "@outschool/auth-shared";
import { useFeatureFlag } from "@outschool/ui-components-shared";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { useQueryParams } from "@patched/hookrouter";
import Cookies from "js-cookie";
import React from "react";

import { PostLoginLearnerConsent } from "../../components/PostLoginLearnerConsent";
import * as Routes from "../../lib/Routes";
import { useLearnerAuth } from "../../providers/LearnerAuthProvider";

/**
 * This page is the first destination after the learner logs in or transfers to
 * learner mode. It is used to set the session token and refresh token in the
 * learner auth provider if they are not already set.
 * As the first destination after auth, it also handles cases like taking
 * consent that need to happen after auth.
 */
export default function RedirectAfterLogin() {
  const { setSessionToken, learnerAuth } = useLearnerAuth();
  const [queryParams] = useQueryParams();
  const enableLearnerConsent = useFeatureFlag("aic-learner-consent-settings");

  const handleDoneWithPostLoginTasks = React.useCallback(() => {
    const redirect = queryParams.redirect || Routes.dashboardPath();
    window?.location.replace(redirect);
  }, [queryParams.redirect]);

  React.useEffect(() => {
    if (learnerAuth) {
      return;
    }
    const sessionToken = Cookies.get(OAUTH2_SESSION_TOKEN);
    Cookies.remove(OAUTH2_SESSION_TOKEN);
    const refreshToken = Cookies.get(OAUTH2_REFRESH_TOKEN);
    Cookies.remove(OAUTH2_REFRESH_TOKEN);
    if (sessionToken) {
      setSessionToken({ sessionToken, refreshToken });
    }

    if (!enableLearnerConsent) {
      handleDoneWithPostLoginTasks();
    }
  }, [
    setSessionToken,
    learnerAuth,
    enableLearnerConsent,
    handleDoneWithPostLoginTasks,
  ]);

  if (!learnerAuth) {
    return null;
  }
  return <PostLoginLearnerConsent onDone={handleDoneWithPostLoginTasks} />;
}
